/* eslint-disable import/prefer-default-export */
import { onMounted, onBeforeUnmount, useSlots, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import { DateTime } from 'luxon';

export function useCustomHeader() {
  const store = useStore();

  onMounted(() => {
    store.commit('SET_STATE_PROPERTY', { property: 'customHeader', value: true });
  });
  onBeforeUnmount(() => {
    store.commit('SET_STATE_PROPERTY', { property: 'customHeader', value: false });
  });
}

export const hasSlot = (name = 'default') => {
  const slots = useSlots();
  return !!slots[name];
};

export const useSidebarWidth = (payload = {}) => {
  const { temporary, type } = payload;

  const widthConfig = {
    default: {
      lg: '320',
      md: '259',
    },
    references: {
      lg: '385',
      md: '348',
    },
  };

  const { lg } = widthConfig[type || 'default'];
  const { md } = widthConfig[type || 'default'];

  const isTemporary = temporary || ref(false);

  const { lgAndUp } = useDisplay();

  const result = computed(() => {
    if (isTemporary.value) return lg;
    return lgAndUp.value ? lg : md;
  });
  return result;
};

export const useIsOverflowed = (el, wrapperEl) => {
  const isOverflowed = ref(false);
  onMounted(() => {
    isOverflowed.value =
      el.value.getBoundingClientRect().width > wrapperEl.value.getBoundingClientRect().width;
  });
  return isOverflowed;
};

export const useFormatDate = (format = 'dd LLL yyyy') => {
  const store = useStore();
  const locale = computed(() => store.state.locale || 'en');

  return (payload) =>
    DateTime.fromJSDate(new Date(payload)).setLocale(locale.value).toFormat(format);
};

export const useCustomDisplay = () => {
  const { width } = useDisplay();

  const w320 = computed(() => width.value < 320);
  return {
    w320,
  };
};
